import { Reducer } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { PROVINCES_AUTO_COMPLETE_REQUEST, PROVINCES_AUTO_COMPLETE_SUCCESSFUL, PROVINCES_AUTO_COMPLETE_FAILURE } from 'action-creators/provincesAutocomplete';
import { RESET } from 'action-creators/generic';
import { ProvinceAutoComplete } from 'models/provinceAutoComplete';

export interface ProvincesAutoCompleteState {
  isLoading: boolean;
  bySearch: ProvinceAutoComplete[];
  error: string | null;
}

const initialState: ProvincesAutoCompleteState = {
  isLoading: false,
  bySearch: [],
  error: null,
};

const reducer: Reducer<ProvincesAutoCompleteState> = (state = initialState, action) => {    
  switch (action.type) {
    case PROVINCES_AUTO_COMPLETE_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case PROVINCES_AUTO_COMPLETE_SUCCESSFUL:
      return {
        ...state,
        bySearch: action.payload,
        isLoading: false,
      };
    case PROVINCES_AUTO_COMPLETE_FAILURE:
      return {
        ...state,
        error: action.payload,
        bySearch: [],
        isLoading: false,
      };
    case RESET:
      return initialState;
    default:
      return state;
  }
};

const persistConfig = {
  storage,
  version: 1,
  key: 'provincesAutoComplete',
  blacklist: ['isLoading', 'error'],
};

export default persistReducer(persistConfig, reducer);
